module.exports = __webpack_public_path__ + "img/sb.85ba2391.svg";